import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as addressActions from '../address/actions';
import * as cartActions from 'components/cart/actions';
import { showAvailability } from 'components/availability/actions';
import ProductEngraving from './engraving';
import DeliveryAvailability from './deliveryAvailability';
import ProductQtySelector from './qtySelector';
import QtyDiscount from './qtyDiscount';

let ProductAddToCart = class ProductAddToCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      engraving: null
    };
  }

  addCart(qty) {
    let opts = {};
    const engraving = this.state.engraving;
    if (
      engraving &&
      (engraving.line_1 || engraving.line_2 || engraving.line_3)
    ) {
      opts.engraving = {
        ...this.state.engraving,
        master_sku: this.props.product.sku_id,
        master_id: this.props.product.cart_id,
        price: this.props.product.engraving.price
      };
    }
    if (this.props.selectedIngredients.length) {
      const products = this.props.selectedIngredients
        .map(i => i.selected)
        .filter(product => !!(product && product.sku_id));
      opts.collection = this.props.product;
      this.props.addSeveral(products, qty, opts);
    } else {
      this.props.addCart(this.props.product, qty, opts);
    }
    setTimeout(this.props.showCart, 500);
  }

  render() {
    const { product, address } = this.props;

    if (!product) return null;

    const notAvailable = !!address && !product.price;
    const disabled = !address || notAvailable || product.soldout;

    return (
      <Fragment>
        {!!product.engraving && (
          <div className="row">
            <div className="col-xs-12">
              <ProductEngraving
                setEngraving={engraving => this.setState({ engraving })}
                product={product}
              />
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xs-12">
            <DeliveryAvailability
              product={product}
              showAvailability={() => this.props.showAvailability()}
            />

            {!!product.price &&
              !!product.package_qty && (
                <QtyDiscount
                  product={product}
                  textProps={{ tag: 'p', weight: 'med' }}
                />
              )}
          </div>
        </div>

        <ProductQtySelector
          defaultQty={1}
          selectorDisabled={disabled}
          buttonDisabled={notAvailable || product.soldout}
          buttonAction={
            address
              ? this.addCart.bind(this)
              : this.props.showAvailability.bind(this)
          }
          buttonText={
            !address
              ? 'Check Availability'
              : product.soldout
                ? 'Sold Out'
                : notAvailable ? 'Currently Unavailable' : 'Add to Cart'
          }
        />
      </Fragment>
    );
  }
};

ProductAddToCart = connect(
  state => ({
    address: state.address.lat ? state.address : null,
    cart: state.cart,
    selectedIngredients: state.product.selectedIngredients
  }),
  {
    ...addressActions,
    ...cartActions,
    showAvailability
  }
)(ProductAddToCart);

export default ProductAddToCart;



// WEBPACK FOOTER //
// ./shared/components/product/addToCart.js